module.exports = __webpack_public_path__ + "static/media/login_bg.8de5c1dd.png";